export default "__VITE_ASSET__CR2pQtfG__"